"use client";

import { motion } from "framer-motion";
import { CalendarCheck2, FileCheck2, UserCheck, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const steps = [{
  num: "01",
  title: "Transfer buchen",
  desc: "Wählen Sie Ihre Route, Abholzeit und Ihr Wunschfahrzeug online oder direkt per WhatsApp aus.",
  icon: CalendarCheck2
}, {
  num: "02",
  title: "Bestätigung erhalten",
  desc: "Unser Team bestätigt Ihnen die Fahrerdetails und genauen Abholhinweise, bevor die Buchung final abgeschlossen wird.",
  icon: FileCheck2
}, {
  num: "03",
  title: "Fahrer treffen",
  desc: "Ihr Fahrer erwartet Sie am Terminal-Ausgang oder in der Hotellobby mit Ihrem Namensschild.",
  icon: UserCheck
}, {
  num: "04",
  title: "Sicher ankommen",
  desc: "Entspannen Sie mit klimatisiertem Komfort auf dem Weg zu Ihrem Ziel und zahlen Sie den Festpreis bei Ankunft.",
  icon: ShieldCheck
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export default function HowItWorks() {
  return <section id="how-it-works" data-nav="light" className="bg-background text-foreground py-20 md:py-24 border-b border-border">
      <div className="max-w-[1136px] mx-auto px-6">
        {/* Header Block */}
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-wider font-semibold text-primary mb-2">
            Einfacher Buchungsablauf
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-bold tracking-tight text-black">
            So funktioniert es
          </h2>

          {/* Signature Hairline Rule with Turquoise Terminal Dot */}
          <div className="relative mt-5 mb-12 flex items-center" aria-hidden="true">
            <div className="h-px bg-border w-28 md:w-36" />
            <div className="size-2 rounded-full bg-primary -ml-1 ring-2 ring-background" />
          </div>
        </div>

        {/* 4 Steps Grid */}
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => {
          const IconComponent = step.icon;
          return <motion.div key={step.num} variants={cardVariants} data-index={i}>
                <Card className="h-full border border-border bg-card rounded-md shadow-2xs hover:border-primary/40 hover:shadow-xs transition-[border-color,box-shadow] duration-200">
                  <CardContent className="p-6 flex flex-col justify-between h-full gap-5">
                    {/* Top Row: Step Number & Icon */}
                    <div className="flex items-center justify-between">
                      <span className="text-2xl font-bold tracking-tight text-foreground/40 font-mono">
                        {step.num}
                      </span>
                      <div className="size-10 rounded-md bg-primary/10 border border-primary/25 flex items-center justify-center text-primary shrink-0">
                        <IconComponent className="size-5" aria-hidden="true" />
                      </div>
                    </div>

                    {/* Step Title & Single Supporting Line */}
                    <div className="space-y-2">
                      <h3 className="text-lg font-semibold text-black tracking-tight">
                        {step.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}